export const containerStyles = `
    flex w-full flex-col flex-1 overflow-y-auto hidden-scrollbar
`
